import { render, staticRenderFns } from "./NoticeBanner.vue?vue&type=template&id=36cf4c14&scoped=true"
import script from "./NoticeBanner.vue?vue&type=script&lang=js"
export * from "./NoticeBanner.vue?vue&type=script&lang=js"
import style0 from "./NoticeBanner.vue?vue&type=style&index=0&id=36cf4c14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf4c14",
  null
  
)

export default component.exports